import { PublicReview } from '@shared/types';
import { FunctionComponent } from 'react';
import styles from './styles.module.scss';

const PublicMessage: FunctionComponent<{ message: PublicReview['publicMessage'] }> = ({
    message,
}) => {
    if (!message) {
        return null;
    }
    return (
        <div className={styles.message} itemProp="reviewBody">
            <p>{message}</p>
        </div>
    );
};

export default PublicMessage;
